import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../../components/Layout';
import Menu from '../../../../components/Layout/Menu';

const StateUpdateContent = lazy(() => import('../../../../components/Pages/States/[stateId]/Update'));

export default function StateUpdate(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: State Update page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <StateUpdateContent />
      </Suspense>
    </Layout>
  );
}
